// In your main component
import PrintableReceipt from "./PrintableReceipt";
import ReceiptComponent from "./ReceiptComponent";
import Receipt from "./Receipt";

const data = {
  // farmerid: "123",
  // username: "John Doe",
  // phone: "555-555-5555",
  // weight: "10",
  // company: "Terraweb Group",
};
const MainPrint = (data) => {

  
  return (
    <div className="w-100 p4">
      {/* <PrintableReceipt data={data} /> */}
      <Receipt data={data} />
      {/* <ReceiptComponent data={data} /> */}
    </div>
  );
};

export default MainPrint;
